import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Backdrop } from '../../primitives/Loading/components/Backdrop.js';
import { Base } from '../../primitives/Loading/components/Base.js';
import { Image } from '../../primitives/Loading/components/Image.js';
import { Layer } from '../../primitives/Loading/components/Layer.js';
import { Fade } from '../../primitives/Transition/index.js';
export const Overlay = /*#__PURE__*/_styled(({
  visible,
  title,
  subtitle,
  icon,
  ...restProps
}) => {
  return _jsx(Fade, {
    in: visible,
    mountOnEnter: true,
    unmountOnExit: true,
    children: _jsx(Backdrop, {
      children: _jsxs(Layer, {
        ...restProps,
        children: [icon && _jsx(Image, {
          width: 100,
          height: 100,
          src: icon
        }), _jsx(Base, {
          title: title,
          subtitle: subtitle
        })]
      })
    })
  });
}, process.env.NODE_ENV === "production" ? {
  target: "enuvcgj0"
} : {
  target: "enuvcgj0",
  label: "Overlay"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk92ZXJsYXkuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBU0ciLCJmaWxlIjoiT3ZlcmxheS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4LCBqc3hzIGFzIF9qc3hzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBCYWNrZHJvcCB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvTG9hZGluZy9jb21wb25lbnRzL0JhY2tkcm9wLmpzJztcbmltcG9ydCB7IEJhc2UgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL0xvYWRpbmcvY29tcG9uZW50cy9CYXNlLmpzJztcbmltcG9ydCB7IEltYWdlIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9Mb2FkaW5nL2NvbXBvbmVudHMvSW1hZ2UuanMnO1xuaW1wb3J0IHsgTGF5ZXIgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL0xvYWRpbmcvY29tcG9uZW50cy9MYXllci5qcyc7XG5pbXBvcnQgeyBGYWRlIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9UcmFuc2l0aW9uL2luZGV4LmpzJztcbmV4cG9ydCBjb25zdCBPdmVybGF5ID0gc3R5bGVkKCh7IHZpc2libGUsIHRpdGxlLCBzdWJ0aXRsZSwgaWNvbiwgLi4ucmVzdFByb3BzIH0pID0+IHtcbiAgICByZXR1cm4gKF9qc3goRmFkZSwgeyBpbjogdmlzaWJsZSwgbW91bnRPbkVudGVyOiB0cnVlLCB1bm1vdW50T25FeGl0OiB0cnVlLCBjaGlsZHJlbjogX2pzeChCYWNrZHJvcCwgeyBjaGlsZHJlbjogX2pzeHMoTGF5ZXIsIHsgLi4ucmVzdFByb3BzLCBjaGlsZHJlbjogW2ljb24gJiYgX2pzeChJbWFnZSwgeyB3aWR0aDogMTAwLCBoZWlnaHQ6IDEwMCwgc3JjOiBpY29uIH0pLCBfanN4KEJhc2UsIHsgdGl0bGU6IHRpdGxlLCBzdWJ0aXRsZTogc3VidGl0bGUgfSldIH0pIH0pIH0pKTtcbn0pIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9T3ZlcmxheS5qcy5tYXAiXX0= */");